import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalNewInvitationService } from './modal-new-invitation.service';
import { RegexEmail, RegexOnlyLetters } from '@config/regex.config';
import { ToastService } from '../toast/toast.service';

@Component({
  selector: 'ggi-journey-modal-new-invitation',
  templateUrl: './modal-new-invitation.component.html',
  styleUrls: ['./modal-new-invitation.component.scss'],
})
export class ModalNewInvitationComponent implements OnInit {
  @Input() visitId: string;

  public form: FormGroup;
  public successModal = false;

  constructor(
    private readonly service: ModalNewInvitationService,
    private readonly fb: FormBuilder,
    private readonly toast: ToastService
  ) {}

  ngOnInit(): void {
    this.form = this.generateForm();
  }

  private generateForm(): FormGroup {
    return this.fb.group({
      email: ['', [Validators.required, Validators.pattern(RegexEmail)]],
      firstName: [
        '',
        [
          Validators.required,
          Validators.pattern(RegexOnlyLetters),
          Validators.maxLength(50),
        ],
      ],
      lastName: [
        '',
        [
          Validators.required,
          Validators.pattern(RegexOnlyLetters),
          Validators.maxLength(50),
        ],
      ],
    });
  }

  public close(): void {
    this.service.close();
    this.service.reloadGetGuests(true);
  }

  public copyLink(): void {
    const link = document.createRange();
    link.selectNode(document.getElementById('link'));
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(link);
    document.execCommand('copy');
  }

  public sendInvitation(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.toast.error();
      return;
    }

    const { lastName, firstName, email } = this.form.value;

    const data = {
      name: {
        firstName,
        lastName,
      },
      email,
      hostUserType: 'client',
    };

    this.service
      .addGuessVisit(data, this.visitId)
      .subscribe(() => this.showSuccess());
  }

  public showSuccess(): void {
    this.successModal = true;
  }

  public backToForm(): void {
    this.successModal = false;
    this.form.reset();
  }
}
